import { documentLogo, evaluationLogo } from 'src/support/logos';
import { GUEST_TYPE } from 'src/user/auth';

export function logo(activity, item) {
  switch (activity.resourceType) {
    case 'html_doc':
      return 'document';
    case 'evaluation':
      return evaluationLogo(item);
    case 'document':
      return documentLogo(item);
    case 'embed':
      return 'link';
    case 'module_moodle':
      return 'out';
    case 'module_scorm':
      return 'out';
    case 'livestream':
      return 'video--on';
    case 'email_marker':
      return 'mail';
    case 'upload_marker':
      return 'pen--alt';
    default:
      return null;
  }
}

export function isVisible({ visibilityMode, visibilityStartDate, visibilityEndDate, guestType = GUEST_TYPE.TRAINEE }) {
  if (guestType !== GUEST_TYPE.TRAINEE) return true;
  if (visibilityMode === 'ALWAYS') return true;
  if (visibilityMode === 'DATE') {
    const today = Date.now();
    const start = new Date(visibilityStartDate).setHours(0, 0, 0, 0);
    const end = new Date(visibilityEndDate).setHours(23, 59, 59, 999);
    return start <= today && end >= today;
  }
  return false;
}

export function isElearning({ sequenceType }) {
  return sequenceType === 'ELEARNING';
}

export function isPositioning({ sequenceType }) {
  return sequenceType === 'POSITIONING';
}

export function isResource({ sequenceType }) {
  return sequenceType === 'RESOURCE';
}
